import Subject from './subject';

export default Subject;
